<template>
  <div class="w-full bg-gray-100">
    <div class="p-4 max-w-4xl m-auto flex justify-between">
      <div>
        <router-link to="/">
          projects
        </router-link>
      </div>
      <div v-if="user">
        {{ user.displayName }}
        <span
          class="cursor-pointer"
          @click="logout">[logout]</span>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data () {
      return {
        user: null
      }
    },

    created () {
      firebase.auth().onAuthStateChanged(user => {
        this.user = user
        if (user == null) return this.login()
      })
    },

    methods: {
      login () {
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithRedirect(provider)
      },
      logout () {
        firebase.auth().signOut()
        this.login()
      }
    }
  }
</script>
